import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
// 引入企业资质资格序列表选择页面
import CorpQualificationList from "../../components/corpQualificationListChoose/index.vue";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      },
      // 表单错误
      errRules: {
        id: null, // 主键
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: null, // 页面类型
      activeName: null, // 一览切换的name
      detailsUrl: "/corpQualificationLevel/detail", // 请求url
    };
  },
  // 注册组件
  components: {
    // 企业资质资格序列表弹框
    CorpQualificationList,
  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取页面类型
    this.controllerFlg = this.$route.query.type;
    // 获取一览切换的name
    this.activeName = this.$route.query.activeName;
    // 判断
    if(this.activeName === "1"){ // 企业资质等级
      // 替换显示form
      this.formConfigList = FormConfig.configList(); 
      // 替换请求url
      this.detailsUrl = "/corpQualificationLevel/detail";
      // 替换表单对象
      this.form = {
        id: null, // 主键
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      };
      // 替换表单错误信息
      this.errRules = {
        levelNum: null, // 编号
        level: null, // 等级
        typNum: null, // 资质类型
      };
    }else if(this.activeName === "2"){ // 企业资质资格序列
      // 替换显示form
      this.formConfigList = FormConfig.corpQualificationList(); 
      // 替换请求url
      this.detailsUrl = "/corpQualificationList/detail";
      // 替换表单对象
      this.form = {
        id: null, // 主键
        certTypeNum: null, // 资质资格类型
        listCode: null, // 编码
        listName: null, // 序列名称
        parentList: null, // 上级序列
        overAllFlag: null, // 综合标志
      };
      // 替换表单错误信息
      this.errRules = {
        certTypeNum: null, // 资质资格类型
        listCode: null, // 编码
        listName: null, // 序列名称
        parentList: null, // 上级序列
        overAllFlag: null, // 综合标志
      };
    }else{ // 企业资质资格专业类别
      // 替换显示form
      this.formConfigList = FormConfig.corpTradetypeBound(); 
      // 替换请求url
      this.detailsUrl = "/corpTradetypeBound/detail";
      // 替换表单对象
      this.form = {
        id: null, // 主键
        tradeLargeClassName: null, // 专业大类名称
        tradeLargeClass: null, // 专业大类
        tradeCategoryCode: null, // 专业小类编码
        tradeCategoryName: null, // 专业小类名称
      };
      // 替换表单错误信息
      this.errRules = {
        tradeLargeClassName: null, // 专业大类名称
        tradeLargeClass: null, // 专业大类
        tradeCategoryCode: null, // 专业小类编码
        tradeCategoryName: null, // 专业小类名称
      };
    }
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
    }
    // 如果是修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction(this.detailsUrl, {
        id: this.$route.query.id
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * @description 保存或修改
     * @author
     */
    fun_SaveOrUpdate() {
      // 遍历错误消息
      for (let i in this.errRules) {
        // 设置为空
        this.errRules[i] = null;
      }
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 声明
          var subUrl = "/corpQualificationLevel/saveOrUpdate";
          // 判断
          if(this.activeName === "1"){ // 企业资质等级
            // 更换url
            subUrl = "/corpQualificationLevel/saveOrUpdate";
          }else if(this.activeName === "2"){ // 企业资质资格序列
            // 更换url
            subUrl = "/corpQualificationList/saveOrUpdate";
          }else{ // 企业资质资格专业类别
            // 更换url
            subUrl = "/corpTradetypeBound/saveOrUpdate";
          }
          // 请求
          fun_PostAction(subUrl, {
            ...this.form, // form表单数据
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } else {
          // 关闭loading
          this.loading = false;
          // 提示
          this.$alert("页面存在错误信息，请检查后重试！", "warning");
          return false;
        }
      });
    },
    /**
     * 专业大类选择
     */
    fun_GetCorpQualificationList(){
      // 打开弹窗
      this.$refs.corpQualificationList.dialogVisible = true;
      // 请求接口
      this.$refs.corpQualificationList.fun_GetOpen();
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    }
  }
};
